module.exports = __webpack_public_path__ + "static/media/gi.4217c0d8.svg";